/* eslint-disable */
import http from "../../api/http"; /** file configured to make requests to the server with fetch */
import auth from "../../auth";
var _ = require("lodash");
const actions = {
    FetchLanguage({commit},payload) {
        return http.get("languages", payload).then(response => {
            if (_.has(response, "DATA") && response.STATUS_CODE == 1) {
                commit('SetLanguage',response.DATA);
            } 
            return response;
        });
    },
    FetchRole({commit},payload) {
        return http.get("roles", payload).then(response => {
            if (_.has(response, "DATA") && response.STATUS_CODE == 1) {
                commit('SetRole',response.DATA);
            } 
            return response;
        });
    },
    FetchKeys({commit},payload) {
        return http.get("keys", payload).then(response => {
            return response;
        });
    },
    FetchStore({commit},payload) {
        return http.get("store", payload).then(response => {
            return response;
        });
    },
    FetchLogActivity({commit},payload) {
        return http.get("logActivity", payload).then(response => {
            return response;
        });
    },
    FetchStatsActivity({commit},payload) {
        return http.get("statsActivity", payload).then(response => {
            return response;
        });
    },
    FetchVideo({commit},payload) {
        return http.get("video", payload).then(response => {
            return response;
        });
    },
    FetchVideoguides({commit},payload) {
        return http.get("video_guide", payload).then(response => {
            return response;
        });
    },
};
export default actions;